import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { Button, ColumnConfiguration } from '@act/storybook';

export const SurveyTableColumns = (
  openAssignmentConfigEditor: (boolean) => void,
  setSelectedSurveyId: (number) => void
): ColumnConfiguration<SurveyV2.SurveyDto>[] => [
  {
    id: 'name',
    value: (props: SurveyV2.SurveyDto) => props.name,
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Name',
  },
  {
    id: 'displayName',
    value: (props: SurveyV2.SurveyDto) => props.name,
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Display Name',
  },
  {
    id: 'isActionSurvey',
    value: (props: SurveyV2.SurveyDto) =>
      props.isActionSurvey ? 'True' : 'False',
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Action Survey',
  },
  {
    id: 'assignmentConfiguration',
    value: (props: SurveyV2.SurveyDto) => (
      <Button
        variant="outlined"
        onClick={() => {
          setSelectedSurveyId(props.id);
          openAssignmentConfigEditor(true);
        }}
      >
        Edit Configuration
      </Button>
    ),
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: false,
    title: 'Assigment Configuration',
  },
  {
    id: 'id',
    value: () => (
      <Button
        variant="outlined"
        disabled // TODO: Eventually UPDATE survey content
        onClick={() => console.log('update survey content here')}
      >
        (Future) Edit Content
      </Button>
    ),
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: false,
    title: 'Edit Content',
  },
];
